import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Page, Header, Alert } from 'components';
import { Grid, Card, CardContent, CardHeader, Divider } from '@mui/material';
import _ from 'underscore';

import ParameterPlanningTable from './components/ParameterPlanningTable';
import ParameterPlanningForm from './components/ParameterPlanningForm';

import { GetVismonLastUpdate, GetSiteList, GetParameterPlanningTable } from '../actions/ParameterPlanningActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const ParameterPlanning = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const parameterPlanningTableData = useSelector((state) => state.parameterPlanningReducer.parameterPlanningTableData);
	const vismonLastUpdate = useSelector((state) => state.parameterPlanningReducer.vismonLastUpdate);
	const siteList = useSelector((state) => state.parameterPlanningReducer.siteList);

	useEffect(() => {
		dispatch(GetVismonLastUpdate());
		dispatch(GetParameterPlanningTable());
		dispatch(GetSiteList());
	}, []);

	return (
		<Page className={classes.root} title="Planning">
			<Header module="Planning" view="Parameter Planning" />
			<Alert
				className={classes.container}
				variant="info"
				message={_.isUndefined(vismonLastUpdate) ? 'Dump date unavailable!' : vismonLastUpdate}
			/>
			<Card className={classes.container} container spacing={3}>
				<CardHeader title="Parameter Planning" />
				<Divider />
				<CardContent>
					<ParameterPlanningForm className={classes.results} sites={siteList} />
				</CardContent>
			</Card>
			<Card className={classes.container} container spacing={3}>
				<CardHeader title="Parameter Planning History" />
				<Divider />
				<CardContent>
					<Grid container spacing={2}>
						<Grid item lg={12} xs={12}>
							<ParameterPlanningTable className={classes.results} data={parameterPlanningTableData} />
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</Page>
	);
};

export default ParameterPlanning;
